import { render, staticRenderFns } from "./AddVideos.vue?vue&type=template&id=36c52c69&scoped=true"
import script from "./AddVideos.vue?vue&type=script&lang=js"
export * from "./AddVideos.vue?vue&type=script&lang=js"
import style0 from "./AddVideos.vue?vue&type=style&index=0&id=36c52c69&prod&scoped=true&lang=css"
import style1 from "./AddVideos.vue?vue&type=style&index=1&id=36c52c69&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c52c69",
  null
  
)

export default component.exports